import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomePage } from './home.page';

const routes: Routes = [
  {
    path: '',
    component: HomePage,
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./dashboard/dashboard.module').then(
            (m) => m.DashboardPageModule
          ),
      },
      {
        path: 'stats',
        loadChildren: () =>
          import('./stats/stats.module').then((m) => m.StatsPageModule),
      },
      {
        path: 'badges',
        loadChildren: () =>
          import('./badges/badges.module').then((m) => m.BadgesPageModule),
      },
      {
        path: 'wallet',
        loadChildren: () =>
          import('./wallet/wallet.module').then((m) => m.WalletPageModule),
      },
      {
        path: 'profile',
        loadChildren: () =>
          import('./profile/profile.module').then((m) => m.ProfilePageModule),
      },
      {
        path: '',
        redirectTo: '/dashboard',
        pathMatch: 'full',
      },
    ],
  },
  //
  // Por limitações do Ionic, faz-se necessário declarar aqui as rotas que não devam exibir o menu principal inferior.
  // Em uma arquitetura mais "limpa", deveriam estar abaixo do módulo da página a que pertencem.
  //,
  {
    path: 'badges/admin',
    loadChildren: () =>
      import('./badges/admin/admin.module').then((m) => m.AdminPageModule),
  },
  {
    path: 'badges/manage',
    loadChildren: () =>
      import('./badges/manage/manage.module').then((m) => m.ManagePageModule),
  },
  {
    path: 'badge-detail',
    loadChildren: () =>
      import('../modals/badge-detail/badge-detail.module').then(
        (m) => m.BadgeDetailPageModule
      ),
  },
  {
    path: 'badge-confirmation',
    loadChildren: () =>
      import('../modals/badge-confirmation/badge-confirmation.module').then(
        (m) => m.BadgeConfirmationPageModule
      ),
  },
  {
    path: 'confirmation',
    loadChildren: () =>
      import('../modals/confirmation/confirmation.module').then(
        (m) => m.ConfirmationPageModule
      ),
  },
  {
    path: 'prompt',
    loadChildren: () =>
      import('../modals/prompt/prompt.module').then((m) => m.PromptPageModule),
  },
  {
    path: 'wallet',
    loadChildren: () =>
      import('./wallet/wallet.module').then((m) => m.WalletPageModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class HomePageRoutingModule {}
